import { memo, useState } from "react";
import { Grid2, Typography, Link, InputAdornment } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useNavigate } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import AccountCircle from "@mui/icons-material/AccountCircle";
import EmailIcon from "@mui/icons-material/Email";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

import { useSnackbar } from "../utils/index.js";
import Spinner from "../components/Spinner.js";
import background from "../assets/images/background.png";
import { signUp } from "../api/index.js";
import Form from "../components/Form.js";

const useStyles = makeStyles((theme) => ({
	root: {
		overflow: "hidden",
		width: "100vw",
		height: "100%",
		backgroundImage: `url(${background})`,
		backgroundPosition: "center",
		backgroundSize: "cover",
	},
	title: {
		color: theme.palette.common.white,
		letterSpacing: theme.spacing(1),
		maxWidth: "300px",
	},
	subtitle: {
		color: theme.palette.secondary.main,
		letterSpacing: theme.spacing(0.1),
		maxWidth: "300px",
	},
}));

const SignUp = () => {
	const [isSubmitting, setIsSubmitting] = useState(false);
	const classes = useStyles();
	const { success, error } = useSnackbar();
	const navigate = useNavigate();

	const [showPassword, setShowPassword] = useState(false);

	const handleShowPassword = () => {
		setShowPassword(!showPassword);
	};

	const submitHandler = async (values) => {
		setIsSubmitting(true);

		try {
			const { success: successCode, message } = await signUp(values.username, values.email, values.password);

			if (successCode) {
				success(message);
				navigate("/");
			} else {
				error(message);
			}
		} catch (error_) {
			console.log(error_);
		}

		setIsSubmitting(false);
	};

	const formContent = [
		{
			customType: "input",
			id: "username",
			type: "text",
			placeholder: "Username",
			inputProps: {
				endAdornment: (
					<InputAdornment position="start">
						<IconButton disabled>
							<AccountCircle />
						</IconButton>
					</InputAdornment>
				),
			},
		},
		{
			customType: "input",
			id: "email",
			type: "email",
			placeholder: "E-mail",
			inputProps: {
				endAdornment: (
					<InputAdornment position="start">
						<IconButton disabled>
							<EmailIcon />
						</IconButton>
					</InputAdornment>
				),
			},
		},
		{
			customType: "input",
			id: "password",
			type: showPassword ? "text" : "password",
			placeholder: "Password",
			inputProps: {
				endAdornment: (
					<InputAdornment position="start">
						<IconButton
							aria-label="toggle password visibility"
							tabIndex={-1}
							onClick={handleShowPassword}
						>
							{showPassword ? <Visibility /> : <VisibilityOff />}
						</IconButton>
					</InputAdornment>
				),
			},
		},
		{
			customType: "input",
			id: "confirmPassword",
			type: showPassword ? "text" : "password",
			placeholder: "Re-type Password",
			inputProps: {
				endAdornment: (
					<InputAdornment position="start">
						<IconButton
							aria-label="toggle password visibility"
							tabIndex={-1}
							onClick={handleShowPassword}
						>
							{showPassword ? <Visibility /> : <VisibilityOff />}
						</IconButton>
					</InputAdornment>
				),
			},
		},
		{
			customType: "button",
			id: "submit",
			type: "submit",
			text: "Sign Up",
		},
	];

	return (
		<>
			<Spinner open={isSubmitting} />
			<Grid2 container direction="row" justifyContent="center" align="center" className={classes.root}>
				<Grid2 item container direction="column" justifyContent="center" align="center" sm={5} xs={12} sx={{ "> .MuiGrid-item": { p: 1 } }}>
					<Grid2 item mt={2}>
						<Typography variant="h4" className={classes.title}>{"Sign Up"}</Typography>
						<Typography variant="h5" className={classes.subtitle}>{"to eenspector Platform"}</Typography>
					</Grid2>
					<Grid2 item container direction="column" justifyContent="center" alignItems="center">
						<Form content={formContent} validationSchema="signUpSchema" onSubmit={submitHandler} />
					</Grid2>
					<Grid2 item container direction="column" justifyContent="center" alignItems="space-between">
						<Grid2 item>
							<Typography variant="h7" color="white.main">{"Otherwise, "}</Typography>
							<Typography variant="h7" className={classes.subtitle}>
								<Link color="inherit" underline="none" href="/">{"Sign In"}</Link>
							</Typography>
						</Grid2>
					</Grid2>
				</Grid2>
				<Grid2 item sm={7} />
			</Grid2>
		</>
	);
};

export default memo(SignUp);
